// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"commission_dashboardContainer__4xK9m","MuiGrid-item":"commission_MuiGrid-item__UMG7D","MuiPaper-root":"commission_MuiPaper-root__DrNpj"};